import { useSelector } from "react-redux";

import { RootState } from "@/store/reducers";

import { Spinner } from "../Elements";

export const UserSpinner = () => {
  return (
    <div className="absolute top-1/2 left-1/2">
      <Spinner size="lg" />
    </div>
  );
};

export const Loading = () => {
  const { isLoading } = useSelector((state: RootState) => state.progress);

  return <>{isLoading && <UserSpinner />}</>;
};
